// The green ring on the pricing cards follows the reader instead of sitting on one plan.
//
// Mid-Sized is rendered with the ring already on it, so that is what a reader with no JS,
// or one who never touches the cards, sees. From there:
//
//   pointer   hover a card and the ring moves to it; leave the row and it goes back
//   touch     tap a card and the ring stays there, since there is no hover to leave
//   keyboard  tab to a card's link and the ring follows the focus
//
// The "Most shops" badge deliberately does not move. That is a claim about the Mid-Sized
// plan, not a label for whatever you are pointing at.
//
// Nothing here is load-bearing: the ring is emphasis, every plan's price and features are
// on the page whatever is highlighted. So there is no ARIA and no roving tabindex, and a
// broken script costs a visual nicety rather than the content.
(function () {
  var ON = 'sw-plan--on';

  function init(grid) {
    if (grid.dataset.swPlansReady) return;
    grid.dataset.swPlansReady = '1';

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-plan-card]'));
    if (cards.length < 2) return;

    // Whatever the reader last committed to by tapping. Until then, the plan the theme
    // marked as featured. May be null if no plan is featured, which clears the ring.
    var selected = grid.querySelector('[data-plan-default]') || null;

    function show(card) {
      cards.forEach(function (c) {
        if (c === card) c.classList.add(ON);
        else c.classList.remove(ON);
      });
    }

    // Hover is bound only where hovering is real. iOS synthesises a mouseenter on first
    // tap, and binding both would make one tap select through two code paths.
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    cards.forEach(function (card) {
      if (canHover) {
        card.addEventListener('mouseenter', function () { show(card); });
      }

      // A tap commits. Clicks on the CTA are not intercepted — the link still navigates,
      // this just runs first and is thrown away with the page.
      card.addEventListener('click', function () {
        selected = card;
        show(card);
      });

      card.addEventListener('focusin', function () { show(card); });
    });

    grid.addEventListener('mouseleave', function () { show(selected); });

    grid.addEventListener('focusout', function (e) {
      // Moving between two links inside the row is not leaving it.
      if (e.relatedTarget && grid.contains(e.relatedTarget)) return;
      show(selected);
    });

    show(selected);
  }

  function boot() { document.querySelectorAll('[data-sw-plans]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
